import React from 'react'
import BookOpenTextSVG from "../../assets/icons/BookOpenText.svg";

const BookOpenText = ({ className = '' }) => {
  return (
    <img
      src={BookOpenTextSVG}
      alt="Book Open Text"
      className={`${className}`}
    />
  );
};

export default BookOpenText;
